export default () => new Promise(resolve => requestAnimationFrame(resolve))
